import { MirrorFeatures, useBoardContext } from "@rastreabilidadebrasil/tageditor";
import { Button } from "@mui/material";
import { SymmetryHorizontal } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

const MirrorVertical = (props: { mirrorFeature: MirrorFeatures | undefined }) => {
  const { board } = useBoardContext();
  const { t } = useTranslation("editor");
  return (
    <Button
      className="btn"
      startIcon={<SymmetryHorizontal size={16} />}
      onClick={() => props.mirrorFeature?.mirror("vertical")}
      disabled={!board?.activeObjects.length}
    >
      {t("Espelhamento vertical")}
    </Button>
  );
};

export default MirrorVertical;
